import React from 'react'
import { TextFieldProps } from '@material-ui/core/TextField'
import { CreateContactInput } from 'src/legacy_graphql'
import {
  Div,
  Flex,
  Input,
  Select,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { useState } from 'src/hooks'
import HoverTooltip from 'src/chrome/HoverTooltip/HoverTooltip'
import { OptionItems } from '../ContactForm/ContactForm'
type Props<T extends CreateContactInput> = {
  contact: T
  onChange: (update: Partial<T>) => void
  countries: string[]
  fields: Pick<TextFieldProps, 'style'>
  regions?: string[]
  isInvalidRegion?: boolean
  isRegionsUnavailable: boolean
}

const BasicAddressForm = <T extends CreateContactInput>(props: Props<T>) => {
  const {
    contact: { address1, address2, city, state, postalCode, country },
    onChange,
    isInvalidRegion,
    regions,
    countries,
    isRegionsUnavailable,
  } = props

  const getIndex = (
    name: string | null | undefined,
    array: string[] | undefined,
  ) => {
    if (array && name) {
      const index = array.indexOf(name)
      if (index >= 0) {
        return index
      }
    }
    return undefined
  }

  const [stateOptionIndex, setStateOptionIndex] = useState<number | undefined>(
    getIndex(state, regions),
  )
  const [countryOptionIndex, setCountryOptionIndex] = useState<
    number | undefined
  >(getIndex(country, countries))

  const handleChange = <K extends keyof T>(key: K, value: T[K]) => {
    onChange(({ [key]: value } as unknown) as Partial<T>)
  }

  return (
    <>
      <Spacer space="x3" />
      <Flex flexDirection="column" rowGap="x3">
        <Div>
          <Text type="caption">Address 1</Text>
          <Input
            type="text"
            value={address1 ? address1 : ''}
            isFullWidth={true}
            placeholder="Address 1"
            onChange={value => handleChange('address1', value)}
            name="address_1_field"
            maxLength={100}
          />
        </Div>
        <Div>
          <Text type="caption">Address 2</Text>
          <Input
            type="text"
            value={address2 ? address2 : ''}
            isFullWidth={true}
            placeholder="Address 2"
            onChange={value => handleChange('address2', value)}
            name="address_2_field"
            maxLength={100}
          />
        </Div>
        <Flex justifyContent="flex-start" columnGap="x2" flexWrap="wrap">
          {isRegionsUnavailable && (
            <Div>
              <Text type="caption">Postal Code</Text>
              <Input
                type="text"
                value={postalCode ? postalCode : ''}
                placeholder="Postal Code"
                onChange={value => handleChange('postalCode', value)}
                maxLength={20}
              />
            </Div>
          )}
          <Div>
            <Text type="caption">City</Text>
            <Input
              type="text"
              value={city ? city : ''}
              placeholder="City"
              onChange={value => handleChange('city', value)}
              name="city_field"
              maxLength={50}
            />
          </Div>
          {!isRegionsUnavailable && (
            <Div display="flex" flexDirection="column" flexGrow={1}>
              <HoverTooltip
                title="Please select a region"
                shouldDisplayTooltip={isInvalidRegion ? true : false}
                isFullWidth={true}
                background="dark"
              >
                <Text
                  type="caption"
                  color={isInvalidRegion ? 'danger' : 'primaryBody'}
                >
                  State
                </Text>
              </HoverTooltip>
              <Select
                selectedOptionIndex={stateOptionIndex}
                onChange={selectedOptionIndex => {
                  setStateOptionIndex(selectedOptionIndex)
                  handleChange(
                    'state',
                    regions ? regions[selectedOptionIndex] : 'United States',
                  )
                }}
                alignment="center"
                options={(regions || ['United States']).map((region, index) => {
                  const optionItem: OptionItems = {
                    value: `${index}`,
                    label: region,
                  }
                  return optionItem
                })}
                type="text"
                dropDownMaxHeight="250px"
                selectHeight="50px"
              />
            </Div>
          )}
          {!isRegionsUnavailable && (
            <Div>
              <Text type="caption">Postal Code</Text>
              <Input
                type="text"
                value={postalCode ? postalCode : ''}
                placeholder="Postal Code"
                onChange={value => handleChange('postalCode', value)}
                maxLength={20}
              />
            </Div>
          )}
          <Div display="flex" flexDirection="column" flexGrow={1}>
            <HoverTooltip
              title="Please select a country"
              shouldDisplayTooltip={false}
              isFullWidth={true}
              background="dark"
            >
              <Text type="caption" color="primaryBody">
                Country
              </Text>
            </HoverTooltip>
            <Select
              selectedOptionIndex={countryOptionIndex}
              onChange={selectedOptionIndex => {
                setStateOptionIndex(undefined)
                handleChange('state', ' ')
                setCountryOptionIndex(selectedOptionIndex)
                handleChange('country', countries[selectedOptionIndex])
              }}
              alignment="center"
              options={countries.map((country, index) => {
                const optionItem: OptionItems = {
                  value: `${index}`,
                  label: country,
                }
                return optionItem
              })}
              type="text"
              dropDownMaxHeight="250px"
              selectHeight="50px"
            />
          </Div>
        </Flex>
      </Flex>
    </>
  )
}

export default BasicAddressForm
